import {
  Button,
  Input,
  StyledReactSelect,
} from '@fountain/fountain-ui-components';
import { Grid, TextField, Typography } from '@material-ui/core';
import {
  AutomatedResponsesDetail,
  MessageTemplateDetail,
} from 'api-clients/monolith';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import globalMessages from 'shared/global/messages';

import messages from './messages';
import { useStyles } from './styles';

export interface AddViewAutomatedResponseProps {
  selectedAutomatedResponse: AutomatedResponsesDetail;
  setSelectedAutomatedResponse: React.Dispatch<
    React.SetStateAction<AutomatedResponsesDetail | null>
  >;
  messageTemplates: MessageTemplateDetail[];
}

export const AddViewAutomatedResponse: FC<AddViewAutomatedResponseProps> = ({
  selectedAutomatedResponse,
  setSelectedAutomatedResponse,
  messageTemplates,
}) => {
  const styles = useStyles();
  const selectedTemplate = messageTemplates.find(
    option => option.id === selectedAutomatedResponse.message_template_id,
  ) ?? { id: 0, name: '' };

  return (
    <Grid className={styles.addAutomatedResponse}>
      <div className={styles.addAutomatedResponseForm}>
        <Grid item xs={12} md={12} className={styles.inputContent}>
          <Typography variant="subtitle1" className={styles.label}>
            <FormattedMessage {...messages.question} />
          </Typography>
          <Input
            fullWidth
            value={selectedAutomatedResponse.question ?? ''}
            data-testid="automated-response-question"
            disabled
            className={styles.inputText}
          />
        </Grid>
        <Grid item xs={12} md={12} className={styles.inputContent}>
          <Typography variant="subtitle1" className={styles.label}>
            <FormattedMessage {...messages.intent} />
          </Typography>
          <Input
            fullWidth
            value={selectedAutomatedResponse.intent ?? ''}
            data-testid="automated-response-intent"
            disabled
            className={styles.inputText}
          />
        </Grid>
        <Grid item xs={12} md={12} className={styles.inputContent}>
          <Typography variant="subtitle1" className={styles.label}>
            <FormattedMessage {...messages.messageTemplates} />
          </Typography>
          <Grid data-testid="automated-response-messageTemplate">
            <StyledReactSelect
              options={messageTemplates}
              getOptionLabel={(option: { name: string }) => option.name}
              getOptionValue={(option: { id: string }) => option.id}
              value={selectedTemplate}
              canSelectAll={false}
              isTargetDisabled={false}
              showArrow={false}
              target={false}
              inlineSearch={false}
              isDisabled
              className={styles.inputText}
            />
          </Grid>
        </Grid>
        <Grid item xs={12} md={12} className={styles.inputContent}>
          <Typography variant="subtitle1" className={styles.label}>
            <FormattedMessage {...messages.message} />
          </Typography>
          <TextField
            variant="outlined"
            value={selectedAutomatedResponse.message ?? ''}
            data-testid="automated-response-message"
            fullWidth
            multiline
            rows={3}
            rowsMax={10}
            disabled
            className={styles.inputText}
          />
        </Grid>
        <Grid item xs={12} md={12} className={styles.inputContent}>
          <Typography variant="subtitle1" className={styles.label}>
            <FormattedMessage {...messages.label} />
          </Typography>
          <Input
            fullWidth
            type="number"
            value={selectedAutomatedResponse.label ?? ''}
            data-testid="automated-response-label"
            disabled
            className={styles.inputText}
          />
        </Grid>
        <Grid>
          <Button
            type="secondary"
            onClick={() => setSelectedAutomatedResponse(null)}
          >
            <FormattedMessage {...globalMessages.cancel} />
          </Button>
        </Grid>
      </div>
    </Grid>
  );
};
